<!-- TEMPLATE -->
<template>
  <transition name="modal">
    <div class="modal-mask" v-if="showModal">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body" @click="">
            <slot name="body">
              <component :is="getModalComponent" :payload-data="getPayload"
                         :key="getPayload.currentPageNumber != null ? getPayload.currentPageNumber : component"
                         @setLoad="setLoading">
                <dean-load-overlay name="load" slot="load" v-if="isLoading"></dean-load-overlay>
              </component>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<!-- SCRIPT -->
<script lang='ts'>
import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import {deanDialogBus} from '@/main';
import Logout from '@/views/auth/logout.vue';
import DetailsDialog from '@/components/dialogs/DetailsDialog.vue';
import OrderAddOrderlineDialog from '@/views/orders/dialogs/orderAddOrderlineDialog.vue';
import OrderMigrateOrderLinesDialog from '@/views/orders/dialogs/orderMigrateOrderLinesDialog.vue';
import ProvisionServicesDialog from '@/views/orders/dialogs/provisionServicesDialog.vue';
import OrderChangeStatus from '@/views/orders/dialogs/orderChangeStatusDialog.vue';
import OrderCancelOrderlineDialog from '@/views/orders/dialogs/orderCancelOrderlineDialog.vue';
import OrderViewLastMessageDialog from '@/views/orders/dialogs/viewMessagesDialog.vue';
import OrderImportOrderlinesDialog from '@/views/orders/dialogs/orderImportOrderlinesDialog.vue';
import ImportOdidoSubscriptionsDialog from '@/views/orders/dialogs/importOdidoSubscriptionsDialog.vue';
import {deanLoadOverlay} from '@deanone/dean-components';
import DeleteContactDialog from '@/components/dialogs/deleteContactDialog.vue';
import DeleteUserDialog from '@/components/dialogs/deleteUserDialog.vue';
import QuoteWinDialog from '@/views/quotes/dialogs/winDialog.vue';
import QuoteLoseDialog from '@/views/quotes/dialogs/loseDialog.vue';
import QuoteRemoveDialog from '@/views/quotes/dialogs/QuoteRemoveDialog.vue';
import QuoteRemoveServiceDialog from '@/views/quotes/dialogs/RemoveServiceDialog.vue';
import PricePlanEntryDeleteDialog from '@/views/standingData/dialogs/pricePlanEntryDeleteDialog.vue';
import StandingDataPeriodDialog from '@/views/standingData/dialogs/periodDialog.vue';
import PricePlanPeriodDialog from '@/views/standingData/dialogs/pricePlanPeriodDialog.vue';
import StandingDataCommissionPercentageDialog from '@/views/standingData/dialogs/commissionPercentageDialog.vue';
import StandingDataGateDialog from '@/views/standingData/dialogs/gateDialog.vue';
import ProductDeleteDialog from '@/views/standingData/dialogs/productDeleteDialog.vue';
import ViewLogStackTrace from '@/views/standingData/dialogs/viewLogStackTrace.vue';
import CustomerServicesProperties from '@/views/customers/services/dialogs/serviceProperties.vue';
import CustomerServicesAddAdditionalProduct from '@/views/customers/services/dialogs/serviceAddAdditionalProduct.vue';
import CustomerServicesChangeProduct from '@/views/customers/services/dialogs/serviceChangeProduct.vue';
import SelectOptionDialog from '@/components/dialogs/selectOptionDialog.vue';
import DeletePartnerDialog from '@/views/partners/dialogs/deletePartnerDialog.vue';
import BlockPartnerDialog from '@/views/partners/dialogs/blockPartnerDialog.vue';
import CustomerStatusChangeDialog from '@/views/customers/dialogs/customerStatusChangeDialog.vue';
import PartnerStatusChangeDialog from '@/views/partners/dialogs/partnerStatusChangeDialog.vue';
import AddAddressDialog from '@/views/quotes/dialogs/addAddressDialog.vue';
import AddPhoneNumberRangeDialog from '@/views/orders/dialogs/addPhoneNumberRangeDialog.vue';
import EditSimCardDetailsDialog from '@/views/orders/dialogs/editSimCardDetailsDialog.vue';
import AddPhoneNumberDialog from '@/views/orders/dialogs/addPhoneNumberDialog.vue';
import TerminatePhoneNumberDialog from '@/views/customers/partition/dialogs/terminatePhoneNumberDialog.vue';
import TerminatePhoneNumberBlockDialog from '@/views/customers/partition/dialogs/terminatePhoneNumberBlockDialog.vue';
import TerminatePartitionDialog from '@/views/customers/partition/dialogs/terminatePartition.vue';
import AddCommentDialog from '@/views/orders/dialogs/addCommentDialog.vue';
import EditKpnProvisioningDetailsDialog from '@/views/orders/dialogs/editKpnProvisioningDetailsDialog.vue';
import CancelProvisioningConfirmationDialog from '@/views/orders/dialogs/cancelProvisioningConfirmationDialog.vue';
import ChangeMsisdnDialog from '@/views/orders/dialogs/changeMsisdnDialog.vue';
import ViewStatusLogDialog from '@/views/orders/dialogs/viewStatusLogDialog.vue';
import ViewOrderStatusLogDialog from '@/views/orders/dialogs/viewOrderStatusLogDialog.vue';

@Component({
  components: {
    Logout,
    DetailsDialog,
    OrderAddOrderlineDialog,
    OrderMigrateOrderLinesDialog,
    ProvisionServicesDialog,
    OrderChangeStatus,
    OrderCancelOrderlineDialog,
    OrderViewLastMessageDialog,
    OrderImportOrderlinesDialog,
    ImportOdidoSubscriptionsDialog,
    deanLoadOverlay,
    DeleteContactDialog,
    DeleteUserDialog,
    QuoteWinDialog,
    QuoteLoseDialog,
    PricePlanEntryDeleteDialog,
    StandingDataPeriodDialog,
    PricePlanPeriodDialog,
    StandingDataCommissionPercentageDialog,
    StandingDataGateDialog,
    ProductDeleteDialog,
    ViewLogStackTrace,
    CustomerServicesProperties,
    CustomerServicesAddAdditionalProduct,
    CustomerServicesChangeProduct,
    SelectOptionDialog,
    DeletePartnerDialog,
    BlockPartnerDialog,
    QuoteRemoveDialog,
    QuoteRemoveServiceDialog,
    PartnerStatusChangeDialog,
    CustomerStatusChangeDialog,
    AddAddressDialog,
    AddPhoneNumberRangeDialog,
    AddPhoneNumberDialog,
    EditSimCardDetailsDialog,
    TerminatePhoneNumberDialog,
    TerminatePhoneNumberBlockDialog,
    TerminatePartitionDialog,
    AddCommentDialog,
    EditKpnProvisioningDetailsDialog,
    CancelProvisioningConfirmationDialog,
    ChangeMsisdnDialog,
    ViewStatusLogDialog,
    ViewOrderStatusLogDialog,
  },
})

export default class DeanModal extends Vue {
  public showModal: boolean = false;
  public component: string = '';
  public result: [] = [];
  public isLoading: boolean = false;

  get getPayload() {
    return (this.result != null) ? this.result : {};
  }

  get getModalComponent() {
    return this.component;
  }

  public setLoading(value: any) {
    this.isLoading = value;
  }

  public mounted() {
    /**
     * Close modal
     */
    deanDialogBus.$on('close', () => {
      this.showModal = false;
    });

    /**
     * Open modal
     */
    deanDialogBus.$on('open', (component: string, result: any) => {
      this.component = component;
      this.result = result;
      this.showModal = true;
    });

    /**
     * Close event watcher
     */
    this.$on('close', () => {
      this.showModal = false;
    });
  }
}

</script>

<!-- STYLE -->
<style lang='scss' scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

.modal-mask {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .5s ease;

  :deep(table td[role="cell"]) {
    vertical-align: top;
  }

  :deep(.dialog.small) {
    font-size: 100%;
  }

  :deep(.row) {
    margin-left: 0;
    margin-right: 0;
  }

  :deep(.dean-dialog-container) {
    :deep(.dean-dialog-content) {

      :deep(.dean-dialog-button-group) {
        overflow: hidden;
        @include border-radius(10px);
      }
    }
  }

  :deep(.dean-input-field) {
    display: flex;
    justify-content: flex-end;
    align-content: center;
    position: relative;
    width: 100%;
    padding: 5px 10px 5px 10px;

    input {
      padding: 10px;
      height: 40px;
      background: none;
      background: linear-gradient(to left, #FFF 50%, #f9f9f9 50%);
      background-size: 200% 100%;
      background-position: right bottom;
      border: 1px solid #F5F5F5;
      font-size: 13px;
      width: 100%;
      //@include calc(width, "100% - 20px")
      @include border-radius(10px);
      @include transition(all ease 0.8s);

      &:focus {
        outline: none;
        background-position: left bottom;
        box-shadow: 0 0 10px 2px var(--color-secondary, $color-secondary);
        padding: 18px 10px 2px 10px;
      }

      &:-webkit-autofill {
        border: 1px solid rgba(0, 0, 0, 0.025);
      }

      &:-webkit-autofill ~ .label {
        top: -1px;
        font-size: 7.5pt;
        color: rgba(0, 0, 0, 0.2);
      }

      &:-webkit-autofill ~ .show-password {
        fill: rgba(0, 0, 0, 0.2);
      }

      &:-webkit-autofill ~ .show-password-active {
        fill: #00839b;
      }

      &:focus ~ .label {
        top: -1px;
        font-size: 7.5pt;
        color: #00839b;
      }

      &[value=''] ~ .label {
        opacity: 1;
      }

      &:disabled {
        color: #B6B6B6;
        font-family: "Avenir-Medium", Tahoma, Helvetica, sans-serif;
        cursor: not-allowed;
        //font-weight: bold;
      }
    }

    .label {
      position: absolute;
      left: 10px;
      top: 5px;
      height: 30px;
      padding: 10px;
      font-family: "Avenir-Medium", Tahoma, Helvetica, sans-serif;
      user-select: none;
      color: #B6B6B6;
      pointer-events: none;
      overflow: hidden;
      @include opacity(1, 0.8s);
      @include transition(all ease 0.4s);
      @include text-select-none();

      .required-field {
        color: #D70019;
      }
    }

    .shrink-label {
      top: -1px;
      font-size: 7.5pt;
      opacity: 1;
    }

    .warning {
      border: 1px solid var(--color-info-warning, $color-info-warning);
    }

    .disabled {
      display: inline-flex;
      position: absolute;
      justify-content: flex-end;
      align-content: center;
      padding: 12.5px;
      height: 40px;
      width: 40px;
      cursor: not-allowed;
      fill: #B6B6B6;
      @include border-radius(100px);

      .icon {
        background: rgba(255, 255, 255, 0.8);
      }
    }

    .show-password {
      display: inline-flex;
      position: absolute;
      justify-content: flex-end;
      align-content: center;
      padding: 12.5px;
      cursor: pointer;
      fill: #B6B6B6;
    }

    .show-password-active {
      fill: #00839b;
    }

    .show-password-focus {
      box-shadow: 0 0 10px 2px #f0faff;
    }
  }

  div.v-select.warning > div {
    border: 1px solid var(--color-info-warning, $color-info-warning);
  }
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  transition: all .5s ease;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

:deep(.dean-load-overlay) {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;

  :deep(.dean-overlay) {
    position: absolute;
  }
}

:deep(.table) {
  width: 100%;
}

:deep(.table .headRow > th) {
  font-family: Barlow, Tahoma, Helvetica, sans-serif;
  text-transform: uppercase;
  font-style: italic;
}

:deep(.table .tableRow > td > .form-control) {
  width: 100%;
}

:deep(.dean-switch) {
  margin: 0 auto;
}

:deep(.dialog-block) {
  :deep(span.block-title) {
    padding-left: 20px;
    font-size: 10pt;
    // color: $color-black;
    font-weight: 700;
    font-style: italic;
    text-transform: uppercase;
  }
}

</style>
